import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import GlobalItem from './GlobalItem';
import DrawerTriggerInner from '../styled/DrawerTriggerInner';

var DrawerTrigger = function (_PureComponent) {
  _inherits(DrawerTrigger, _PureComponent);

  function DrawerTrigger() {
    _classCallCheck(this, DrawerTrigger);

    return _possibleConstructorReturn(this, (DrawerTrigger.__proto__ || _Object$getPrototypeOf(DrawerTrigger)).apply(this, arguments));
  }

  _createClass(DrawerTrigger, [{
    key: 'render',
    value: function render() {
      if (this.props.children == null) return null;
      return React.createElement(
        DrawerTriggerInner,
        null,
        React.createElement(
          GlobalItem,
          {
            role: 'button',
            'aria-haspopup': 'true',
            onClick: this.props.onActivate,
            onMouseDown: function onMouseDown(e) {
              return e.preventDefault();
            },
            size: 'medium'
          },
          this.props.children
        )
      );
    }
  }]);

  return DrawerTrigger;
}(PureComponent);

DrawerTrigger.defaultProps = {
  onActivate: function onActivate() {}
};
export default DrawerTrigger;